import type { StateRoute } from "@/lib/states-config";

export const stateSelectorDataTestIds = {
  TRIGGER_BUTTON: "state-selector-trigger",
  DIALOG: "state-selector-dialog",
  DIALOG_TITLE: "state-selector-dialog-title",
  DIALOG_DESCRIPTION: "state-selector-dialog-description",
  STATE_LIST: "state-selector-list",
  STATE_CARD: "state-selector-card",
  STATE_ABBREVIATION: "state-selector-abbreviation",
  STATE_NAME: "state-selector-name",
  STATE_BADGE: "state-selector-badge",
  STATE_SUBTITLE: "state-selector-subtitle",
  FOOTER_TEXT: "state-selector-footer",
} as const;

export type StateCardTestId =
  `${typeof stateSelectorDataTestIds.STATE_CARD}-${StateRoute}`;

export function getStateCardTestId(route: StateRoute): StateCardTestId {
  return `${stateSelectorDataTestIds.STATE_CARD}-${route}`;
}
